// stylePageConfigs.ts
import logoExtended from "../../../../assets/images/paisley-background-dark.jpg";
import backgroundV1 from "../../../../assets/images/paisley-background-v1.png";
import backgroundV2 from "../../../../assets/images/paisley-background-v2.png";
import backgroundV3 from "../../../../assets/images/paisley-background-v3.png";

export interface StylePageConfig {
  backgroundImage?: string;
  backgroundRepeat?: string;
  backgroundSize?: string;
  overlay?: string;
}

export const stylePageConfigs: Record<string, StylePageConfig> = {
  Paisley: {
    backgroundImage: `url(${logoExtended})`,
    backgroundRepeat: "repeat",
    backgroundSize: "auto",
    overlay: "rgba(255, 255, 255, 0.9)",
  },
  "Paisley 2": {
    backgroundImage: `url(${backgroundV1})`,
    backgroundRepeat: "repeat",
    backgroundSize: "auto",
    overlay: "rgba(255, 255, 255, 0.15)",
  },
  "Paisley 3": {
    backgroundImage: `url(${backgroundV2})`,
    backgroundRepeat: "repeat",
    backgroundSize: "auto",
    overlay: "rgba(255, 255, 255, 0.15)",
  },
  "Paisley 4": {
    backgroundImage: `url(${backgroundV3})`,
    backgroundRepeat: "repeat",
    backgroundSize: "auto",
    overlay: "rgba(255, 255, 255, 0.15)",
  },
  White: {
    backgroundImage: undefined,
    overlay: "rgba(255, 255, 255, 0.9)",
  },
};

export const defaultStylePage = "Paisley";
